import reviewsData from "./reviews.json";

export const reviews = reviewsData;

export const homeReviews = reviewsData.filter((r) => r.showOnHome);
